import { render, staticRenderFns } from "./Test.vue?vue&type=template&id=ad9f1e4c&scoped=true"
import script from "./Test.js?vue&type=script&lang=js&external"
export * from "./Test.js?vue&type=script&lang=js&external"
import style0 from "./Test.scss?vue&type=style&index=0&id=ad9f1e4c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad9f1e4c",
  null
  
)

export default component.exports